<template lang="pug">
.v-product-list.product-list
	.product-list__grid
		.product-list__cell(v-for="(item, index) in displayedItems" :key="item.id || index")
			template(v-if="item.type === 'top' || item.type === 'vip5' || item.type === 'highlight' || item.type === 'standard'" )
				v-product(:template="template" :product="item" :quick-view="quickView")
			template(v-else)
				v-page-banner(:data-source="item")
</template>

<script>
export default {
	computed: {
		displayedItems() {
			const result = [...(this.items || [])];
			const vip5Indexes = [];
			const vip5Items = [];

			const productTypes = ['top', 'vip5', 'highlight', 'standard'];
			for (let index = 0; index < result.length; index++) {
				const itemType = result[index]?.type;
				if (itemType === 'vip5') {
					vip5Indexes.push(index);
					vip5Items.push(result[index]);
					continue;
				}
				// Advertising banners keep their fixed cadence and do not end the
				// leading VIP block. The first non-VIP product does.
				if (productTypes.includes(itemType)) {
					break;
				}
			}

			for (let index = vip5Items.length - 1; index > 0; index--) {
				const randomIndex = Math.floor(Math.random() * (index + 1));
				[vip5Items[index], vip5Items[randomIndex]] = [vip5Items[randomIndex], vip5Items[index]];
			}
			vip5Indexes.forEach((itemIndex, index) => {
				result[itemIndex] = vip5Items[index];
			});

			return result;
		}
	},

	props: {
		template: {
			type: String,
			default: 'list'
		},

		items: {
			type: Array,
			default: null
		},

		quickView: {
			type: Boolean,
			default: false
		}
	}
};
</script>
